import React from "react";

// Grey stand-in for a project card while posts load. Pass a className that
// gives it the real card's size, so it takes the same spot in the grid.
const SkeletonCard: React.FC<{ className?: string }> = ({ className }) => (
  <div
    className={`${className ?? ""} flex flex-col bg-white rounded-3xl shadow-md py-5 px-6`}
    aria-hidden="true"
  >
    <div className="skeleton h-6 w-2/3 rounded-md" />
    <div className="skeleton h-3 w-2/5 rounded-md mt-2" />
    <div className="flex flex-col gap-2 mt-4">
      <div className="skeleton h-3.5 w-full rounded-md" />
      <div className="skeleton h-3.5 w-11/12 rounded-md" />
      <div className="skeleton h-3.5 w-full rounded-md" />
      <div className="skeleton h-3.5 w-3/5 rounded-md" />
    </div>
    <div className="flex gap-1.5 mt-4">
      <div className="skeleton h-5 w-14 rounded-full" />
      <div className="skeleton h-5 w-12 rounded-full" />
    </div>
    <div className="mt-auto flex items-center gap-3 bg-gray-f6 rounded-[18px] py-2 pl-2 pr-3.5">
      <div className="skeleton w-9 h-9 rounded-full shrink-0" />
      <div className="skeleton h-3 flex-1 rounded-md" />
    </div>
  </div>
);

export default SkeletonCard;
